import { UseQueryOptions } from '@tanstack/react-query';

import Pipeline from 'types/pipeline';
import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

import { initializeAPIPipeline } from './usePipelines';

export function usePipeline(
  id: string | null | undefined,
  { enabled, ...options }: UseQueryOptions<Pipeline, APIError> = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['pipeline', id, applicationID],
    async () => {
      if (!id) {
        return Promise.reject('No pipeline ID provided.');
      }

      const { data } = await client.get<Pipeline>(
        `/apps/${applicationID}/pipelines/${id}`
      );

      const pipeline = new Pipeline(
        data.id,
        data.name,
        data.application_id,
        data.definition,
        data.created_at,
        data.updated_at
      );

      return initializeAPIPipeline(pipeline);
    },
    {
      ...options,
      enabled: enabled !== undefined ? enabled && Boolean(id) : Boolean(id),
      // FIXME Remove refetchOnWindowFocus: false when React Flow editor is implemented
      refetchOnWindowFocus: false,
    }
  );
}
